class Registry {
  custom = []
  types = {}
  groups = {}

  register (type, options, custom = false) {
    const exists = this.types[type]
    if (exists) {
      throw new Error(`Part ${type} is already registered.`)
    }

    this.types[type] = options
    if (!this.groups[options.group]) this.groups[options.group] = []
    this.groups[options.group].push(type)
    if (custom) this.custom.push(type)
  }

  get (type) {
    return this.types[type]
  }

  list () {
    return Object.keys(this.groups).map(groupName => ({
      label: groupName,
      options: this.groups[groupName].map(type => ({
        value: type, text: this.types[type].name
      }))
    }))
  }

  unregisterCustom () {
    this.custom.forEach(type => {
      const options = this.types[type]
      if (options && options.group) {
        const group = this.groups[options.group]
        group.splice(group.indexOf(type), 1)
      }

      delete this.types[type]
    })
    this.custom = []
  }
}

const registry = new Registry()
export default registry



// WEBPACK FOOTER //
// ./app/registry.js